export default {
    install: (app) => {
        app.config.globalProperties.$notify = (options, duration = 8000) => {
            // Remove existing notification with same group if clean is true
            if (options.clean) {
                const existingToasts = document.querySelectorAll(
                    `.toast.${options.group}`
                );
                existingToasts.forEach((toast) => toast.remove());
                return;
            }

            const toast = document.createElement('div');
            toast.className = `toast ${options.group}`;

            const toastBody = document.createElement('div');
            toastBody.className =
                'toast-body flex items-start rounded overflow-hidden';

            // Add icon based on type
            const iconWrapper = document.createElement('div');
            iconWrapper.className = 'shrink-0 mr-3 mt-1';

            if (options.data?.type === 'progress') {
                iconWrapper.innerHTML = `
                    <svg class="animate-spin h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>`;
            } else {
                const iconColor =
                    options.group === 'success'
                        ? 'text-green-400'
                        : options.group === 'error'
                          ? 'text-red-400'
                          : 'text-blue-400';
                iconWrapper.innerHTML = `<svg class="h-5 w-5 ${iconColor}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    ${
                        options.group === 'success'
                            ? '<path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>'
                            : options.group === 'error'
                              ? '<path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>'
                              : '<path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>'
                    }
                </svg>`;
            }
            toastBody.appendChild(iconWrapper);

            const contentWrapper = document.createElement('div');
            if (options.title) {
                const title = document.createElement('div');
                title.className = 'font-bold text-lg text-white mb-2';
                title.textContent = options.title;
                contentWrapper.appendChild(title);
            }

            const text = document.createElement('div');
            text.className = 'font-normal text-sm text-white';
            text.textContent = options.text;
            contentWrapper.appendChild(text);
            toastBody.appendChild(contentWrapper);

            const closeBtn = document.createElement('button');
            closeBtn.className = 'close-toast text-xl ml-auto';
            closeBtn.innerHTML = '×';
            closeBtn.onclick = () => toast.remove();
            toastBody.appendChild(closeBtn);

            toast.appendChild(toastBody);
            document.body.appendChild(toast);

            // Trigger reflow to enable transition
            toast.offsetHeight;
            toast.classList.add('up');

            // Only set timeout for non-progress notifications
            if (options.data?.type !== 'progress') {
                setTimeout(() => {
                    toast.classList.remove('up');
                    setTimeout(() => toast.remove(), 350);
                }, duration);
            }
        };
    },
};
